<template>
  <v-app-bar id="upp-bar" color="white" :flat="true" class="px-4">
    <div class="d-flex align-center">
      <v-icon color="primary" class="mr-2" size="large">
        mdi-graph-outline
      </v-icon>
      <a
        class="text-primary text-h5 text-decoration-none font-weight-light"
        href="/dts"
      >
        {{ $t("labels.page-title") }}
      </a>
      <v-icon>mdi-chevron-right</v-icon>
      <v-tooltip location="bottom" color="primary">
        <template v-slot:activator="{ props }">
          <div
            class="text-primary text-h5 font-weight-bold text-truncate"
            v-bind="props"
          >
            {{ modelDT.modelName }}
          </div>
        </template>
        <span>{{ modelDT.modelName }}</span>
      </v-tooltip>
    </div>
    <v-spacer></v-spacer>
    <div class="d-flex align-center">
      <div class="text-primary text-h5 font-weight-bold text-truncate">
        {{ capitalizeFirstLetter(modelDT.domain) }}
      </div>
    </div>
    <v-spacer></v-spacer>
    <v-menu location="bottom left">
      <template v-slot:activator="{ props }">
        <v-btn v-bind="props" icon variant="text" color="primary">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item>
          <v-list-item disabled>
            <template v-slot:prepend>
              <v-icon class="opacity-100" color="primary">
                mdi-form-textbox
              </v-icon>
            </template>
            <v-list-item-title>{{ $t("labels.rename") }}</v-list-item-title>
          </v-list-item>
          <v-list-item disabled>
            <template v-slot:prepend>
              <v-icon class="opacity-100" color="primary"> mdi-delete </v-icon>
            </template>
            <v-list-item-title>{{ $t("labels.delete") }}</v-list-item-title>
          </v-list-item>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import { inject } from "vue";

export default {
  props: [],
  data: function () {
    return {
      modelDT: undefined,
    };
  },
  created() {
    this.modelDT = inject("modelDT");
  },
  computed: {},
  methods: {
    capitalizeFirstLetter(str) {
      if (!str) return "";
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
  },
};
</script>
